import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { scan } from 'rxjs/operators';

export interface Role {
  name: string;
}

@Injectable()
export class RolesService {
  roles$ = new ReplaySubject<string[]>(1);
  roleUpdates$ = new BehaviorSubject(['basic']);

  constructor() {
    this.roleUpdates$
      .pipe(
        scan((next) => next, [])
      )
      .subscribe(this.roles$);
  }

  update(roles: any) {
    this.roleUpdates$.next(roles);
  }
}
